export default "/images/b85ae853dbab892133c11a9101561770.avif";